import { QuestionRegulatoryData, Questionnaire, QuestionnaireQuestion } from "../../Models/Surveys/SurveyDataModel";
import { BaseRegulationLogicManager } from "../BaseRegulationLogicManager";
import ResourcesConstants from "../ResourceConstants";
import {ComplianceScoreResult, InventoryDetailsResponse} from "../../StateControllers/Survey/SurveyResponse/SurveyResponseModels";

export class RohsCustomLogicManager extends BaseRegulationLogicManager {
    public static RohsRegulationId = "1c87c8f8-6df6-43ee-b943-ea8801b326ba";

    private readonly subjectToDirectiveKey: string = "rohs_subject_to_directive";
    private readonly meetsRequirementsKey: string = "rohs_meets_requirements";
    private readonly exemptionsKey: string = "rohs_exemptions";
    private readonly containsRestrictedSubstancesKey: string = "rohs_constains_restricted_substances";
    private readonly restrictedSubstancesKey: string = "rohs_restricted_substances";

    constructor(questions: QuestionnaireQuestion[], overallQuestionnaire: Questionnaire, questionRegulatoryData: QuestionRegulatoryData[], selectedInventory: InventoryDetailsResponse | null, complianceScoreResult: ComplianceScoreResult | null) {
        super(questions, overallQuestionnaire, questionRegulatoryData, selectedInventory, complianceScoreResult);
    }

    protected getAdditionalQuestionIndicesToHide = (question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) => {
        let childQuestionIndex = -1;

        switch (question.summaryFieldKey) {
            case this.subjectToDirectiveKey: {
                childQuestionIndex = this._questions.findIndex(q => q.summaryFieldKey == this.meetsRequirementsKey);

                indicesToHideOrShow[childQuestionIndex] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;

                if (childQuestionIndex !== -1) {
                    const childQuestion = this._questions[childQuestionIndex];
                    indicesToHideOrShow = this.getAdditionalQuestionIndicesToHide(childQuestion, questionIndex, indicesToHideOrShow);
                }

                break;
            }
            case this.meetsRequirementsKey: {
                childQuestionIndex = this._questions.findIndex(q => q.summaryFieldKey == this.exemptionsKey);
                indicesToHideOrShow[childQuestionIndex] = question.value !== ResourcesConstants.NativeAnswerTexts.MeetsWithExemptions;
                break;
            }
            case this.containsRestrictedSubstancesKey: {
                childQuestionIndex = this._questions.findIndex(q => q.summaryFieldKey == this.restrictedSubstancesKey);
                indicesToHideOrShow[childQuestionIndex] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
                break;
            }
        }

        return indicesToHideOrShow;
    }
}
